import { createAccountTransactionRegistry } from 'entities/transaction';
import { accountPageTransactionsModel } from '../../model';

const AccountTransactionRegistry = createAccountTransactionRegistry(
	accountPageTransactionsModel.accountTransactionRegistryModel,
);

export const AccountPageTransactions = () => <AccountTransactionRegistry withTitle={false} />;
